import React from "react";
import Title from "./Title";
import resume from "../assets/Resume.pdf";
import { useTranslation } from "react-i18next";

export default function Profile() {
  const { t } = useTranslation();

  return (
    <section id={t("link-profile")} className="profile-section section">
      <Title title={t("profile-title")} />
      <a
        href={resume}
        target="_blank"
        rel="noopener noreferrer"
        className="button"
      >
        {t("profile-button")}
      </a>
    </section>
  );
}
